import { Box, Stack, Container, IconButton } from "@mui/material";
import { FiShare } from "react-icons/fi";
import ListButton from "./ListButton";
import ListIcon from "./ListIcon";
import BrandDetails from "./BrandDetails";
import BgVideo from "./BackgroundVideo";
import VisitStore from "./VisitStore";
import { itemsList } from "../itemsList";
import { useState } from "react";
import ShareModal from "./ShareModal";

export default function BioLink() {
    const [open, setOpen] = useState(false);
    const shareLink = "https://bio.elmascoffee.com";

    return (
        <Box sx={{ minHeight: "100vh", width: "100vw", position: "relative" }}>
            <BgVideo />

            {/* ICON BAR */}
            <Container
                maxWidth="sm"
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                    pt: 5,
                }}>
                {itemsList
                    .filter((item) => item.showInIcons)
                    .map((item) => (
                        <ListIcon
                            key={item.id}
                            href={item.href}
                            icon={item.icon}
                        />
                    ))}
            </Container>

            {/* MAIN CONTENT */}
            <Container
                maxWidth="sm"
                sx={{
                    minHeight: "85vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 4,
                    marginBottom: 4,
                }}>
                <Box
                    sx={{
                        width: "100%",
                        textAlign: "center",
                        background: "rgba(255,255,255,0.3)",
                        backdropFilter: "blur(16px)",
                        borderRadius: 4,
                        p: 4,
                        boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
                        position: "relative",
                    }}>
                    <IconButton
                        onClick={() => setOpen(true)}
                        sx={{ position: "absolute", top: 16, right: 16 }}>
                        <FiShare />
                    </IconButton>

                    <BrandDetails />

                    <Stack spacing={1.5}>
                        <VisitStore />

                        {itemsList
                            .filter((item) => item.showInButtons)
                            .map((item) => (
                                <ListButton
                                    key={item.id}
                                    href={item.href}
                                    text={item.text}
                                />
                            ))}
                    </Stack>
                </Box>
            </Container>

            <ShareModal open={open} setOpen={setOpen} shareLink={shareLink} />
        </Box>
    );
}
